import React from 'react';
import { Reveal } from './Reveal';
const rows = [{
  without: 'Arriver en séance stressé',
  with: '10 min/semaine. Tout prêt.'
}, {
  without: 'Chercher des supports',
  with: '+500 supports + plans hebdomadaires pour toute l\u2019année'
}, {
  without: 'Développement aléatoire des compétences',
  with: 'Progression logique et mesurable'
}, {
  without: 'Chaos et désorganisation du cabinet',
  with: 'Protocoles de discipline et de culture professionnelle'
}, {
  without: 'Stratégie de séance au hasard',
  with: 'Plans cliniques professionnels structurés'
}];
export function Comparison() {
  return <section className="w-full bg-ink-soft px-4 py-20" data-id="element-37">
      <div className="mx-auto max-w-4xl" data-id="element-38">
        <Reveal data-id="element-39">
          <h2 className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-40">
            Votre prochaine séance peut rester improvisée. Ou vous pouvez enfin
            avoir un vrai système.
          </h2>
          <p className="mt-4 text-center text-white/60" data-id="element-41">
            Rejoignez des centaines de professionnels dans le monde entier qui
            planifient déjà toutes leurs interventions en moins de 5 minutes.
          </p>
          <p className="mt-3 text-center text-sm font-semibold uppercase tracking-wide text-gold" data-id="element-42">
            Plans · Activités · Progressions · Gestion · Tout organisé.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-43">
          <div className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-44">
            <div className="rounded-2xl border border-red-500/30 bg-ink-card p-6" data-id="element-45">
              <h3 className="mb-5 text-center font-bold uppercase tracking-wide text-red-400" data-id="element-46">
                Sans le Protocole Clinique
              </h3>
              <ul className="space-y-3" data-id="element-47">
                {rows.map(r => <li key={r.without} className="flex items-start gap-2 text-sm text-white/70" data-id="element-48">
                    <span className="mt-0.5" data-id="element-49">❌</span> {r.without}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-2xl border border-grass/40 bg-ink-card p-6" data-id="element-50">
              <h3 className="mb-5 text-center font-bold uppercase tracking-wide text-grass" data-id="element-51">
                Avec Le Protocole Clinique™
              </h3>
              <ul className="space-y-3" data-id="element-52">
                {rows.map(r => <li key={r.with} className="flex items-start gap-2 text-sm text-white/80" data-id="element-53">
                    <span className="mt-0.5" data-id="element-54">✅</span> {r.with}
                  </li>)}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}